"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeHotspotData = normalizeHotspotData;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * 热区数据归一化工具
 *
 * 历史版本曾把"编辑器画布显示像素"直接存为热区坐标（与屏幕宽度相关，
 * 可能远大于原图 picW/picH），也存在因容器边框导致的 1~2px 越界。
 * 此工具把热区坐标统一修正回原图坐标系，并钳制在图片范围内。
 */

var EPSILON = 0.01;
function toNumber() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  for (var _i = 0, _values = values; _i < _values.length; _i++) {
    var v = _values[_i];
    var n = Number(v);
    if (Number.isFinite(n)) return n;
  }
  return 0;
}
function nearlyEqual(a, b) {
  return Math.abs(toNumber(a) - toNumber(b)) < EPSILON;
}

/**
 * 修正热区配置（settingInfo 结构：{ picW, picH, clickList: [...] }）。
 * - 旧版"显示坐标"数据：按比例整体缩回原图坐标系（保持相对位置）
 * - 轻微越界：直接钳制在 picW × picH 内
 * 返回 { changed, data }；changed 为 false 时 data 与入参语义一致。
 */
function normalizeHotspotData() {
  var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var picW = toNumber(info.picW);
  var picH = toNumber(info.picH);
  var list = Array.isArray(info.clickList) ? info.clickList : [];
  if (picW <= 0 || picH <= 0 || !list.length) {
    return {
      changed: false,
      data: info
    };
  }
  var maxRight = 0;
  var maxBottom = 0;
  var rects = list.map(function (item) {
    var left = toNumber(item.originalLeft, item.left);
    var top = toNumber(item.originalTop, item.top);
    var width = toNumber(item.originalWidth, item.width);
    var height = toNumber(item.originalHeight, item.height);
    maxRight = Math.max(maxRight, left + width);
    maxBottom = Math.max(maxBottom, top + height);
    return {
      left: left,
      top: top,
      width: width,
      height: height
    };
  });

  // 所有热区共享同一个缩放因子，保持彼此相对位置不变
  var factor = Math.min(1, maxRight > 0 ? picW / maxRight : 1, maxBottom > 0 ? picH / maxBottom : 1);
  var changed = false;
  var clickList = list.map(function (item, i) {
    var _rects$i = rects[i],
      left = _rects$i.left,
      top = _rects$i.top,
      width = _rects$i.width,
      height = _rects$i.height;
    if (factor < 1) {
      left *= factor;
      top *= factor;
      width *= factor;
      height *= factor;
    }
    width = Math.max(1, Math.min(width, picW));
    height = Math.max(1, Math.min(height, picH));
    left = Math.max(0, Math.min(left, picW - width));
    top = Math.max(0, Math.min(top, picH - height));
    if (!nearlyEqual(item.left, left) || !nearlyEqual(item.top, top) || !nearlyEqual(item.width, width) || !nearlyEqual(item.height, height) || !nearlyEqual(item.originalLeft, left) || !nearlyEqual(item.originalTop, top) || !nearlyEqual(item.originalWidth, width) || !nearlyEqual(item.originalHeight, height)) {
      changed = true;
    }
    return _objectSpread(_objectSpread({}, item), {}, {
      left: left,
      top: top,
      width: width,
      height: height,
      originalLeft: left,
      originalTop: top,
      originalWidth: width,
      originalHeight: height
    });
  });
  if (!changed) {
    return {
      changed: false,
      data: info
    };
  }
  return {
    changed: true,
    data: _objectSpread(_objectSpread({}, info), {}, {
      clickList: clickList
    })
  };
}